const DpoExportPriloh = {
    progressId: null,

    init: function () {
        const tlacitko = $("#tlacitko-export-priloh");
        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }

                const grid = $('#grid_section_i102');
                const rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                if (!rows.length) {
                    Lemo_Alert.addInfo('Pro export příloh označte alespoň jednu žádost.', 'exportPrilohInfo');
                    return;
                }

                let ids = [];
                $.each(rows, function (i, id) {
                    ids.push(parseInt(id));
                });

                let url = window.location.protocol + "//" + window.location.host;
                url += "/ajax/exportPriloh/nactiFormular";

                $.ajax({
                    type: "post",
                    url: url,
                    dataType: "json",
                    data: {"ids": ids},
                    global: true,
                    success: function (r) {
                        if (r.hasOwnProperty("messages")) {
                            Lemo_Alert.addMany(r.messages);
                        }

                        if (r.hasOwnProperty("status") && true !== r.status) {
                            return;
                        }

                        const progressHash = r.data["progressHash"];

                        WilleModal.setTitle('Export příloh žádostí');
                        WilleModal.disableClose();
                        WilleModal.addButton(
                            "continue",
                            "<i class=\"fa fa-fw fa-check\"></i> Pokračovat",
                            "btn btn-primary",
                            function () {
                                DpoExportPriloh.vytvorArchiv(ids, progressHash);
                            });
                        WilleModal.addButton("cancel",
                            "<i class=\"fa fa-fw fa-check\"></i> Zrušit",
                            'btn btn-danger',
                            function () {
                                Lemo_Alert.closeAll();
                                Promise.all([
                                    WilleModal.close()
                                ]).then(() => {
                                    Lemo_Alert.closeAll();
                                }).catch((messages) => {
                                    console.log(messages);
                                });
                            });
                        WilleModal.setContent(r.html);
                        WilleModal.build();
                    }
                });
            });
    },

    progressCancel: function (progressHash) {
        $.ajax({
            type: "post",
            url: "/ajax/exportPriloh/progressZrusit",
            data: {"progressHash": progressHash},
            dataType: "json",
            global: false,
            success: function () {
                Lemo_Alert.addInfo("Export příloh byl zrušen.", 'exportPrilohZrusen', 5000);
                Lemo_Alert.closeById("exportPriloh");
            },
            complete: function() {
                DynaBase_Overlay.hide()
            }
        });
    },

    progressInfo: function (progressHash) {
        $.ajax({
            type: "post",
            url: "/ajax/exportPriloh/progressInfo",
            data: {"progressHash": progressHash},
            dataType: "json",
            global: false,
            success: function (r) {
                let data = r.data;

                const progressBar = $('#progress');
                if (progressBar.length) {
                    progressBar.find('.progress-bar').text(data["procent"] + '%');
                    progressBar.find('.progress-bar').css('width', data["procent"] + '%');
                }
                const progressBarEta = $('#progress-eta');
                if (progressBarEta.length) {
                    if (null !== data["eta"]) {
                        progressBarEta.text(" Zbývá: " + data["eta"]);
                    } else {
                        progressBarEta.text(" Zbývá: neznámo");
                    }
                }
            }
        });
    },

    vytvorArchiv: function (ids, progressHash) {
        let formData = {};
        formData["ids"] = ids;
        formData["progressHash"] = progressHash;
        formData["typyDokumentu"] = [];

        const typyDokumentu = $("#form-group-modal-typdokumentu").find(":checkbox:checked");
        $(typyDokumentu).each(function (i, el) {
            let value = parseInt($(el).val());
            formData["typyDokumentu"].push(value);
        });

        Promise.all([
            WilleModal.close()
        ]).then(() => {
            let url = window.location.protocol + "//" + window.location.host;
            url += "/ajax/exportPriloh/vytvorArchiv";
            $.ajax({
                type: "post",
                url: url,
                dataType: "json",
                data: formData,
                global: true,
                beforeSend: function () {
                    Lemo_Alert.closeAll();

                    let text = '<p>Export příloh žádostí ... <span id="progress-eta"></span></p>';
                    text += '<div id="progress" class="progress text-center mt-1 mb-2">';
                    text += '    <div class="progress-bar progress-bar-striped active" role="progressbar" style="width: 0;">0%</div>';
                    text += '</div>';
                    text += '<button id="tlacitko-export-priloh-zrusit" class="btn btn-xs btn-danger"><i class="fas fa-trash fa-fw"></i> Zrušit</button>';
                    Lemo_Alert.setShowCloseButton(false);
                    Lemo_Alert.setCloseOnClick(false);
                    Lemo_Alert.addInfo(text, 'exportPriloh', 0);

                    const tlacitkoZrusit = $('#tlacitko-export-priloh-zrusit');
                    if (tlacitkoZrusit.length) {
                        tlacitkoZrusit
                            .off("click")
                            .on("click", function (e) {
                                e.preventDefault();
                                DpoExportPriloh.progressCancel(progressHash);
                            });
                    }

                    DpoExportPriloh.progressId = window.setInterval(function () {
                        DpoExportPriloh.progressInfo(progressHash);
                    }, 2500);
                },
                success: function (r) {
                    if (r.hasOwnProperty("messages")) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    if (r.hasOwnProperty("status") && true !== r.status) {
                        return;
                    }

                    let url = window.location.protocol + "//" + window.location.host;
                    url += "/dpo/export/" + progressHash;
                    setTimeout(function () {
                        Lemo_Alert.closeAll();
                        window.location = url;
                    }, 1000);
                },
                complete: function () {
                    Lemo_Alert.closeById("exportPriloh");
                    if (null !== DpoExportPriloh.progressId) {
                        window.clearInterval(DpoExportPriloh.progressId);
                        DpoExportPriloh.progressId = null;
                    }
                }
            });
        }).catch((messages) => {
            console.log(messages);
        });
    }
};

$(document).ready(function () {
    DpoExportPriloh.init();
});